<template>
  <div class="point-store">
    <ProductSelect />
    <div v-if="selectedProduct" class="purchase-modal-container">
      <PurchaseModal
        :products="products"
        v-scroll-lock="true"
        class="purchase-modal"
        @closePaymentModal="setPaymentModalShow"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex"
import ProductSelect from "../../components/store/pointStore/ProductSelect.vue"
import PurchaseModal from "@/components/payment/PaymentModal.vue"
import { PRODUCT_TYPE } from "@/constants/payment"

export default {
  metaInfo () {
    const title = "Credits Store | ProGuides"
    const description =
      "Getting to your dream rank has never been easier. Never make a bad decision again! Learn strategy, mechanics, and more."
    const keywords =
      "League of Legends course,learn how to play League of Legends,get better at League of Legends,pro League of Legends,League of Legends guides,League of Legends guide,rank up in League,fastest way to learn,League of Legends tips tricks,how to play like a pro,Fortnite course,learn how to play Fortnite,get better at Fortnite,pro Fortnite,Fortnite guides,Fortnite guide,rank up in Fortnite,fastest way to learn,Fortnite tips tricks,how to play like a pro"
    return {
      title,
      meta: [
        { vmid: "title", name: "title", content: title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { name: "keywords", content: keywords },
      ],
    }
  },
  components: {
    ProductSelect,
    PurchaseModal,
  },
  data: function () {
    return {
      productType: PRODUCT_TYPE.POINT_PURCHASE,
    }
  },
  computed: {
    ...mapGetters("Store", [
      "selectedProduct",
      "subscriptionOptions",
      "maxDiscount",
    ]),
    products () {
      return [this.selectedProduct]
    },
  },
  methods: {
    ...mapMutations("Store", ["setSelectedProduct"]),
    ...mapActions("Store", ["getSubscriptionOptions"]),
    setPaymentModalShow () {
      this.setSelectedProduct(null)
    },
  },
  created () {
    window.location.href = "/dashboard/leagueoflegends"
    this.setSelectedProduct(null)
    this.getSubscriptionOptions()
  },
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
}

.point-store {
  background-color: #e8e8e8;
  height: 100%;
  padding: 3rem 1rem;
  overflow: auto;

  .purchase-modal-container {
    position: fixed;
    z-index: 15;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/store/PointStore.vue